<template>
   <ModalWrapper @close="$emit('close')" :open="open">
      <template #header>
         <h3>Edit Class</h3>
         <!-- <h5 class="serif">You can have some extra text about what the standards are? Or we can remove this line of text.</h5> -->
      </template>
      <template #body>
         <FormGenerator
            id="edit-class-form"
            :schema="schema"
            @submit="handleSubmit"
            :initValue="{
               title: currentClass.title,
               discipline_id: currentClass.discipline.id,
            }"
         />
         <ImageField
            :image="currentClass.image"
            @uploadImage="classesStore.uploadImage"
            @removeImage="classesStore.removeImage"
         />

         <div class="archive">
            <h5 class="small mb-1">Please take note!</h5>
            <p class="small">
               Archiving your class will save and permanently lock it in its
               current state. We recommend archiving your classes at the end of
               the academic school year so you may have a record to reflect upon
               next year.
            </p>
            <Btn
               :tabindex="-1"
               buttonType="error"
               v-bind="{
                  text: 'Archive Class',
                  action: true,
               }"
               @handleAction="handleArchive"
            />
         </div>
      </template>
      <template #footer>
         <Btn
            :tabindex="-1"
            buttonType="success"
            v-bind="{
               text: 'Save Changes',
               action: true,
            }"
            @handleAction="handleClick"
         />
      </template>
   </ModalWrapper>
</template>

<script setup lang="ts">
import * as Yup from "yup";
import disciplineOptions from "~/data/discipline-options.json";
const emit = defineEmits(["close"]);
const classesStore = useClassesStore();
const { currentClass } = storeToRefs(classesStore);

const props = defineProps({
   open: { type: Boolean, required: true, default: false },
});

// >> Filtering of the Standards
const schema = reactive({
   fields: [
      {
         label: "Title",
         name: "title",
         as: "input",
         type: "text",
         rules: Yup.string().required(),
      },
      {
         label: "Discipline",
         name: "discipline_id",
         as: "basic-select",
         rules: Yup.string().required(),
         children: disciplineOptions,
      },
   ],
});

// Form Submit
const callHook = useNuxtApp().callHook;
// >> Methods
const handleClick = () => {
   callHook("form:submit", "edit-class-form");
};
const handleSubmit = async (form) => {
   await classesStore.updateClassSettings(form);
};
const handleArchive = async () => {
   await classesStore.archiveClass();
   navigateTo({ name: "profile-classes" });
};
onMounted(() => {});
</script>

<style scoped lang="scss">
/* Add your styles here */

div.archive {
   border-radius: pad(0.5);
   border: 1px solid $red;
   background-color: $red-lt;
   padding: pad(2);
   display: grid;
   grid-template-rows: auto auto;
   grid-template-columns: 1fr auto;
   grid-template-areas:
      "title action"
      "text text";
   align-items: center;
   row-gap: pad(1);
   h5 {
      grid-area: title;
   }
   p {
      grid-area: text;
   }
   button {
      grid-area: action;
   }
}
</style>
